import * as React from 'react'
import { useParams } from 'react-router-dom'

import { UniversalImporterFixProcessPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { ImportProcessDataCollection } from 'modules/universal_importer/components/ImportProcessDataCollection'
import { ImportProcessErrorModal } from 'modules/universal_importer/components/ImportProcessErrorModal'
import { ImportProcessInfoBanner } from 'modules/universal_importer/components/ImportProcessInfoBanner'
import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'
import { Metadata } from 'modules/universal_importer/components/NuvoImporter/types'

const UniversalImporterProcessPage = () => {
  const { importProcessId } = useParams()
  const { navigation } = useNavigation()
  const [isFixModalOpen, setIsFixModalOpen] = React.useState(false)
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const [selectedRowErrors, setSelectedRowErrors] = React.useState<string>('')
  const [selectedRowColumns, setSelectedRowColumns] = React.useState<Record<string, string>>({})

  const {
    company,
    access: { locale },
  } = useCurrentSession()

  const { data, loading } = useQuery(UniversalImporterFixProcessPageDocument, {
    variables: { importProcessId: Number(importProcessId) },
  })

  const importProcess = data?.universalImporter.importProcess
  const metadata: Metadata = {
    import_process_ids: [Number(importProcessId)],
  }
  const legalEntityId = importProcess?.legalEntity?.id
  if (legalEntityId) {
    metadata['legal_entity_ids'] = [Number(legalEntityId)]
  }
  const parentProcessId = importProcess?.id
  const rootProcessId = importProcess?.rootProcessId ?? parentProcessId

  return (
    <ResponsivePage.Body
      variant="full"
      loading={loading}
      error={!importProcess}
      onPrimaryActionClick={() => setIsFixModalOpen(true)}
    >
      <ImportProcessInfoBanner />
      <ImportProcessDataCollection
        setSelectedRowColumns={setSelectedRowColumns}
        setSelectedRowErrors={setSelectedRowErrors}
        setIsModalOpen={setIsModalOpen}
        importProcessId={String(importProcessId)}
      />
      <ImportProcessErrorModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedRowErrors={selectedRowErrors}
        selectedRowColumns={selectedRowColumns}
      />
      {isFixModalOpen && importProcess && (
        <NuvoImporter
          importType={importProcess.importType}
          companyId={company.id}
          locale={locale}
          metadata={metadata}
          isEdition
          customBackNavigation={navigation.settings.universalImporter.universalImporterProcess
            .fullPath({
              importProcessId: Number(importProcessId),
            })
            .replace(/\*+$/, '')}
          parentProcessId={parentProcessId}
          rootProcessId={rootProcessId}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default UniversalImporterProcessPage
